module.exports = __webpack_public_path__ + "autopilot-1-full-e8645d66e51aafafc71452043b0a26e9.webp";